import { get, keyBy, mapValues } from "lodash";
import Box from "@material-ui/core/Box";
import { useState } from "react";
import Signup from "./Signup";
import Signin from "./Signin";
import ForgotPassword from "./ForgotPassword";
import { connect } from "react-redux";
import SigninWelcome from "./SigninWelcome";
import { isLoggedIn } from "../../state/selectors/user";
import { useMount } from "react-use";
import ResetPassword from "./ResetPassword";
import VerifySignup from "./VerifySignup";
import SignupWelcome from "./SignupWelcome";
import ResetNewPassword from "./ResetNewPassword";
import {
  AUTHENTICATOR_FORGOT,
  AUTHENTICATOR_RESET,
  AUTHENTICATOR_RESETNEW,
  AUTHENTICATOR_SIGNIN,
  AUTHENTICATOR_SIGNUP,
  AUTHENTICATOR_VERIFY,
  AUTHENTICATOR_WELCOME,
} from "./constants";

const Authenticator = ({ environment, isLoggedIn, newsletters }) => {
  const [authScreen, setAuthScreen] = useState(AUTHENTICATOR_SIGNUP); // COULD BE SIGNUP/VERIFY/SIGNIN/FORGOT/RESET/RESETNEW/WELCOME
  const [user, setUser] = useState(null); // set user for the reset new password
  const [formValue, setFormValue] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    agreeTerms: false,
    newsletters: [],
  });

  useMount(() => {
    if (newsletters?.length)
      setFormValue({
        ...formValue,
        newsletters,
      });
  });

  return (
    <Box
      style={{
        padding: "80px 50px",
        boxShadow: "-15.7px 19.4px 84px 0 rgba(154, 170, 176, 0.28)",
        borderRadius: "4px",
        minHeight: "486px",
      }}
    >
      {!isLoggedIn ? (
        <>
          {authScreen === AUTHENTICATOR_SIGNUP && (
            <Signup
              environment={environment}
              initialValue={formValue}
              setInitialValue={setFormValue}
              setAuthScreen={setAuthScreen}
            />
          )}

          {authScreen === AUTHENTICATOR_VERIFY && (
            <VerifySignup initialValue={formValue} setAuthScreen={setAuthScreen} />
          )}

          {authScreen === AUTHENTICATOR_SIGNIN && (
            <Signin
              initialValue={formValue}
              setInitialValue={setFormValue}
              setAuthScreen={setAuthScreen}
              setUser={setUser}
            />
          )}

          {authScreen === AUTHENTICATOR_FORGOT && (
            <ForgotPassword
              initialValue={formValue}
              setInitialValue={setFormValue}
              setAuthScreen={setAuthScreen}
            />
          )}

          {authScreen === AUTHENTICATOR_RESET && (
            <ResetPassword initialValue={formValue} />
          )}

          {authScreen === AUTHENTICATOR_RESETNEW && (
            <ResetNewPassword
              setInitialValue={setFormValue}
              setAuthScreen={setAuthScreen}
              user={user}
            />
          )}

          {authScreen === AUTHENTICATOR_WELCOME && (
            <SignupWelcome
              initialValue={formValue}
              setInitialValue={setFormValue}
              setAuthScreen={setAuthScreen}
            />
          )}
        </>
      ) : (
        <>
          <SigninWelcome
            setInitialValue={setFormValue}
            initialValue={formValue}
            setAuthScreen={setAuthScreen}
          />
        </>
      )}
    </Box>
  );
};

// Create data context by using the defined environment variables in the survey
const createContext = (environment) => {
  return mapValues(keyBy(environment, 'name'), 'value');
};

const mapStateToProps = (state) => ({
  environment: createContext(get(state, ["survey", "environment"], [])),
  isLoggedIn: isLoggedIn(state),
});

export default connect(mapStateToProps)(Authenticator);
